import React, { useState } from "react";
import { ChevronDown, Plus, X } from "lucide-react";

export default function RootSheet({ variant = "page" }) {
  const [showRootSheet, setShowRootSheet] = useState(true);
  const [processes, setProcesses] = useState([]);

  const addProcess = () => {
    setProcesses([...processes, {
      id: Date.now(),
      machine: "",
      tool: "",
      employee: "",
      instrument: "",
      accessories: "",
      cost: ""
    }]);
  };

  const updateProcess = (id, field, value) => {
    setProcesses(processes.map((process) => (process.id === id ? { ...process, [field]: value } : process)));
  };

  const removeProcess = (id) => {
    setProcesses(processes.filter((process) => process.id !== id));
  };

  return (
    <div className={variant === "modal" ? "section-card" : "section-card"}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          marginBottom: showRootSheet ? "16px" : "0"
        }}
      >
        <h3 className="section-title" style={{ margin: 0 }}>Production Root Sheet</h3>
        <button className="btn-toggle" type="button" onClick={() => setShowRootSheet(!showRootSheet)}>
          {showRootSheet ? "Hide" : "Show"} <ChevronDown size={14} style={{ transform: showRootSheet ? "rotate(180deg)" : "none" }} />
        </button>
      </div>

      {showRootSheet && (
        <div>
          <div className="form-row">
            <div className="form-group">
              <label>Select Product</label>
              <select className="form-input">
                <option value="">-- Select Product --</option>
                <option>Product A</option>
                <option>Product B</option>
              </select>
            </div>
          </div>

          {processes.map((process, index) => (
            <div key={process.id} className="process-card-item">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                <h4>Process {index + 1}</h4>
                <button className="btn-icon" type="button" onClick={() => removeProcess(process.id)}><X size={14} /></button>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Machine</label><input type="text" className="form-input" placeholder="Machine" value={process.machine} onChange={(e) => updateProcess(process.id, "machine", e.target.value)} /></div>
                <div className="form-group"><label>Tool</label><input type="text" className="form-input" placeholder="Tool" value={process.tool} onChange={(e) => updateProcess(process.id, "tool", e.target.value)} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Employee</label><input type="text" className="form-input" placeholder="Employee" value={process.employee} onChange={(e) => updateProcess(process.id, "employee", e.target.value)} /></div>
                <div className="form-group"><label>Instrument</label><input type="text" className="form-input" placeholder="Instrument" value={process.instrument} onChange={(e) => updateProcess(process.id, "instrument", e.target.value)} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Accessories</label><input type="text" className="form-input" placeholder="Accessories" value={process.accessories} onChange={(e) => updateProcess(process.id, "accessories", e.target.value)} /></div>
                <div className="form-group"><label>Cost</label><input type="text" className="form-input" placeholder="Enter cost" value={process.cost} onChange={(e) => updateProcess(process.id, "cost", e.target.value)} /></div>
              </div>
            </div>
          ))}

          <button className="btn-add" type="button" onClick={addProcess}><Plus size={14} /> Add Process</button>
        </div>
      )}
    </div>
  );
}